import AlertInline from '@storeblocks/inline-alert';
import { type FC } from 'react';

import { useFundListQuery } from '@/api/funds/fundsApi';
import { FundClosedReason } from '@/api/funds/models';
import { OrderType } from '@/api/order/models/OrderType';
import { useTexts } from '@/hooks/useTexts';

import { FundInfo } from './FundInfo';

interface Props {
  isin: string;
  orderType: OrderType.Subscription | OrderType.Redemption;
}

export const ClosedForTradeInfo: FC<Props> = ({ isin, orderType }) => {
  const texts = useTexts();

  const { data: fundList } = useFundListQuery();

  const textMap = {
    [OrderType.Subscription]: {
      [FundClosedReason.FundClosed]:
        texts.orders.form.information.subscription.closedForTrade.fundClosed
          .message,

      [FundClosedReason.UnsupportedCurrency]:
        texts.orders.form.information.subscription.closedForTrade
          .unsupportedCurrency.message,

      [FundClosedReason.MissingMarketingPermission]:
        texts.orders.form.information.subscription.closedForTrade
          .missingMarketingPermission.message,

      [FundClosedReason.UnsupportedFund]:
        texts.orders.form.information.subscription.closedForTrade
          .unsupportedFund.message,
    },

    [OrderType.Redemption]: {
      [FundClosedReason.FundClosed]:
        texts.orders.form.information.redemption.closedForTrade.fundClosed
          .message,

      [FundClosedReason.UnsupportedCurrency]:
        texts.orders.form.information.redemption.closedForTrade
          .unsupportedCurrency.message,

      [FundClosedReason.MissingMarketingPermission]:
        texts.orders.form.information.redemption.closedForTrade
          .missingMarketingPermission.message,

      [FundClosedReason.UnsupportedFund]: '',
    },
  };

  const closedReason = {
    [OrderType.Subscription]:
      fundList!.byIsin[isin].closedForSubscriptionReason,
    [OrderType.Redemption]: fundList!.byIsin[isin].closedForRedemptionReason,
  };

  return (
    <FundInfo>
      <AlertInline
        data-test={`closed-for-trade-${isin}`}
        title={textMap[orderType][closedReason[orderType]!]}
        variant="info"
      />
    </FundInfo>
  );
};
